module.exports = __webpack_public_path__ + "img/a1a059a.jpg";